module.exports = {
  messages: {
    CN: {
      "basicSettings.basicSetting": "基础设置",
      "basicSettings.shopName": "店铺名称",
      "basicSettings.pleaseinputShopName": "请输入店铺名称",
      "basicSettings.operateType": "运营方式",
      "basicSettings.operateTypezero": "多发货渠道，多运输方式",
      "basicSettings.operateTypeOne": "多发货渠道，单运输方式",
      "basicSettings.operateTypeTwo": "单发货渠道，多运输方式",
      "basicSettings.operateTypeThree": "单发货渠道，单运输方式",
      "basicSettings.currencySymbol": "货币符号",
      "basicSettings.currencySymbolPrompt": "左侧显示",
      "basicSettings.currencyUnit": "货币单位",
      "basicSettings.currencyUnitPrompt": "右侧显示",
      "basicSettings.payment": "支付方式",
      "basicSettings.warmPrompt": "温馨提示",
      "basicSettings.warmPromptContent": "拖动的修改将直接影响客户下单时支付方式的展示顺序",
      "basicSettings.paymentTimeout": "支付超时时间",
      "basicSettings.chargesSetting": "手续费设置",
      "basicSettings.Watermark": '商品图片水印',
      "basicSettings.makeCollectionsBankInformation": "收款银行信息",
      "basicSettings.partnerCode": "商户编号",
      "basicSettings.credentialCode": "开发校验码",
      "basicSettings.shopKey": "商户私钥",
      "basicSettings.zfbKey": "支付宝公钥",
      "basicSettings.secret": "秘钥",
      "basicSettings.minute": "分钟",
      "basicSettings.hour": "小时",
      "basicSettings.day": "天",
      "basicSettings.whethertoAllowBlacklistUse": "是否允许黑名单客户使用",
      "basicSettings.enterPleaseName": "请输入名称",
      "basicSettings.enterPleaseNameMakeCollectionsBankInformation": "请输入收款银行信息",
      "basicSettings.enterPleaseClientKey": "请输入client_key",
      "basicSettings.enterPleaseServerKey": "请输入server_key",
      "basicSettings.enterPleasePartnerCode": "请输入商户编号",
      "basicSettings.enterPleaseSecret": "请输入秘钥",
      "basicSettings.enterPleaseCredentialCode": "请输入开发校验码",
      "basicSettings.enterPleaseAppid": "请输入app_id",
      "basicSettings.enterPleaseShopKey": "请输入商户私钥",
      "basicSettings.enterPleasezfbKey": "请输入支付宝公钥",
      "basicSettings.enterPleasePayPayKey": "请输入key",
      "basicSettings.enterPleasePaymentTimeout": "请输入支付超时时间",
      "basicSettings.tipsForUploadingPicture": "建议上传分辨率为 {size} 的图片。上传图片大小不能超过 {uploadLimit} MB",
      "basicSettings.rewardSetting": "积分设置",
      "basicSettings.rewardGiftRatio": "积分赠送比例(%)",
      "basicSettings.rewardGiftRatioErr": "请输入积分赠送比例",
      "basicSettings.oneRewardConversion": "1积分兑换",
      "basicSettings.oneRewardConversionErr": "请输入一积分兑换金额",
      "basicSettings.evaluatePointRate": "评价积分赠送比例(%)",
      "basicSettings.productMoney": "商品金额范围(含税)",
      "basicSettings.PresentedPointNumber": "赠送积分数量",
      "basicSettings.evaluatePresentIntegralList": "评价赠送积分规则列表",
      "basicSettings.rewardValidity": "积分有效期",
      "basicSettings.rewardValidityUnit0": "天",
      "basicSettings.rewardValidityUnit1": "月",
      "basicSettings.rewardValidityUnit2": "年",
      "basicSettings.rewardValidityErr": "请设置积分有效期",
      "basicSettings.transportCompany": "运输公司",
      "basicSettings.showName": "显示名称",
      "basicSettings.parameterConfiguration": "参数配置",
      "basicSettings.newtransportCompany": "新建运输公司",
      "basicSettings.edittransportCompany": "编辑运输公司",
      "basicSettings.MetaTitle": "Meta标题",
      "basicSettings.enterPleaseMetaTitle": "请输入Meta标题",
      "basicSettings.MetaLabelDescription": "Meta标签描述",
      "basicSettings.MetaLabelkeyword": "Meta标签关键字",
      "basicSettings.other": "其他",
      "basicSettings.productInventoryThreshold": "商品库存阈值",
      "basicSettings.productInventoryThresholdPrompt": "库存低于设定阈值后，管理后台提醒管理员",
      "basicSettings.lowstockLimit": "库存紧张阈值",
      "basicSettings.lowstockLimitPrompt": "库存低于设定阈值后，将在购物页面提示“库存紧张”（包括商品详情页、购物车等）",
      "basicSettings.arrivalNoticeThreshold": "到货通知阈值",
      "basicSettings.arrivalNoticeThresholdPrompt": "库存达到该值，自动发送到货通知",
      "basicSettings.maxLoginNum": "最大登录尝试次数",
      "basicSettings.maxLoginNumPrompt": "已经达到最大尝试次数，账户锁定1小时",
      "basicSettings.scopeOfDelivery": "发货范围",
      "basicSettings.clientLanguageDisplay": "客户端语言显示",
      "basicSettings.shopDefaultLanguage": "商城默认语言",
      "basicSettings.SameBundleDelivery": "同捆发货",
      "basicSettings.productComment": "商品评论",
      "basicSettings.showProductComment": "显示商品评论",
      "basicSettings.newCommentEmailAlert": "新评论邮件提醒",
      "basicSettings.stepFreight": "阶梯运费",
      "basicSettings.BaiduTranslateappid": "百度翻译appid",
      "basicSettings.BaiduTranslateappscript": "百度翻译appscript",
      "basicSettings.open": "开启",
      "basicSettings.close": "关闭",
      "basicSettings.piece": "件",
      "basicSettings.arrivalTimeReminder": "到货时间提醒文字",
      "basicSettings.leaveWordReminder": "留言提醒文字",
      "basicSettings.phoneSmsLimit": "每日每个电话/客户短信验证码发送上限",
      "basicSettings.phoneSmsLimitPrompt": "超过该上限，当日将不会再向该电话/客户发送短信验证码",
      "basicSettings.ipSmsLimit": "每日每个IP短信验证码发送上限",
      "basicSettings.ipSmsLimitPrompt": "超过该上限，当日将不会再向该IP所在的电话发送短信验证码",
      "basicSettings.remindSmsLimit": "每日短信验证码发送总量阈值",
      "basicSettings.remindSmsLimitPrompt": "超过阈值后，短信会继续发送，且每次发送后会给管理员邮箱发送超限提醒",
      "basicSettings.emailSetting": "邮件设置",
      "basicSettings.SMTPHost": "SMTP 主机",
      "basicSettings.enterPleaseSMTPHost": "请输入SMTP 主机",
      "basicSettings.SMTPAccount": "SMTP 账号",
      "basicSettings.enterPleaseSMTPAccount": "请输入SMTP 账号",
      "basicSettings.SMTPPassword": "SMTP 密码",
      "basicSettings.enterPleaseSMTPPassword": "请输入SMTP 密码",
      "basicSettings.SMTPPort": "SMTP 端口",
      "basicSettings.enterPleaseSMTPPort": "请输入SMTP 端口",
      "basicSettings.SMTPTimeout": "SMTP 超时（分）",
      "basicSettings.enterPleaseSMTPTimeout": "请输入SMTP 超时（分）",
      "basicSettings.administratorEmail": "管理员邮箱",
      "basicSettings.administratorEmailPrompt": "系统异常通知（请用逗号隔开）",
      "basicSettings.earlyWarning": "系统预警邮件开关",
      "basicSettings.agreementSetting": "规约设置",
      "basicSettings.registerProtocol": "条款及条件",
      "basicSettings.shoppingTerms": "购物条款",
      "basicSettings.returnAndExchangeAgreement": "退货换货协议",
      "basicSettings.privacyPolicy": "隐私政策",
      "basicSettings.pagesetting": '页面设置',
      "basicSettings.customerService": "联系客服",
      "basicSettings.type": "类型",
      "basicSettings.title": "标题",
      "basicSettings.description": "描述",
      "basicSettings.link": "链接",
      "basicSettings.phone": "电话",
      "basicSettings.WeChat": "微信",
      "basicSettings.icon": "图标",
      "basicSettings.qc-play": "微信公众号名称",
      "basicSettings.socialLogin": "社会化登录设置",
      "basicSettings.orderamountShowdays": "客户端订单金额显示天数",
      "basicSettings.emailNotifySetting": "邮件通知设置",
      "basicSettings.emailNotifySetting.title": "邮件签名",
      "basicSettings.emailNotifySetting.tooltip": "可用于设置共同的邮件结束语和邮件签名",
      'Enable': '启用',
      'disabled': '停用',
      'EnableMessage': '确定要启用吗？',
      'disabledMessage': '确定要停用吗？',
      'yes': '是',
      'no': '否',
      'chinese': '简体中文',
      'chinese2': '繁体中文',
      'jp': '日文',
      'preView': '预览',
      'emailNumber': '序号',
      'emailNotify': '通知场景',
      'emailState': '状态',
      'emailAction': '操作',
      'switchSuccess': '点击确定',
      'switchError': '点击取消',
      'more': '更多',
      formModel: {
        title: '-参数编辑'
      },
      notifySetting: {
        title: '-通知设置',
        title2: '通知设置'
      },
      socialLogin: {
        columns: {
          thirdPlatforms: '第三方平台',
          messageNotify: '消息通知'
        },
        'wxParams1': '用于跨平台统一账号,PC端微信扫描登录',
        'wxParams2': '用于消息通知,微信客户端内的登录',
        notify: '通知',
        edit: '编辑',
        decp: '可以进行拖动操作修改排序和序号，以影响展示顺序。',
        wx: '微信',
        qq: 'QQ',
        wb: '新浪微博',
        fb: 'FaceBook',
        line: 'Line',
        wxName1: '微信开放平台',
        wxName2: '海外微信公众号',
        wxName3: '国内微信公众号',
        lineRule1: '请输入Channel ID',
        lineRule2: '请输入Channel Secret',
        lineMessage: '若要打开Line消息通知，请填写Channel access token',
        wxRule1: '请输入App ID',
        wxRule2: '请输入Secret',
        wbRule1: '请输入App Key',
        wbRule2: '请输入App Serect',
        copy: '复制',
        open: '开启',
        socialLogin: '社会化登录',
        look: '查看',
        nftoken: '请先编辑配置Channel access token'
      },
      transPort: {
        url: '官网查询网址',
        name: '显示名称',
        rule1: '请选择运输公司',
        rule2: '请输入显示名称'
      },
      account: {
        emailAccount: '账号',
        name: '姓名',
        state: '状态',
        updateTime: '更新时间',
        accountName: '账号',
        EnableMessage: '确定要删除吗？',
        modifyPwd: '修改密码',
        delete: '删除',
        edit: '编辑',
        admin: '管理员',
        pwdRule1: '请输入确认密码',
        pwdRule2: '两次密码输入不一致',
        pwdRule3: '请输入新密码',
        pwdRule4: '请输入密码',
        nameRule: '请输入姓名',
        changePwd: '修改密码',
        emailRule: '请输入合法的邮箱',
        emailRule2: '请输入账号',
        pwd: '密码',
        newPwd: '新密码',
        confirmPwd: '确认密码',
        confirmPwdPlace: '请输入确认密码',
        setAdmin: '设为管理员',
        yes: '是',
        no: '否',
        pwdLength: '请将密码设置为4位数以上长度',
        userLength: '请将账号设置为2位数以上长度',
        nameLength: '请将姓名设置为2位数以上长度'
      },
      deploy: {
        siteDomainName: '站点域名',
        title1: '用于拼接站点页面资源的完整路径',
        title2: '用于拼接站点接口资源的完整路径',
        title3: '用于拼接图片资源的完整路径',
        siteInterfacePrefix: '站点接口前缀',
        pictureDomainName: '图片域名',
        ysDataSync: '友盛数据同步',
        open: '开启',
        close: '关闭',
        googleStatus: 'Google统计',
        fbStatus: 'Facebook统计',
        aliInvalidMailSync: '无效邮箱同步',
        tbjs: '同步检索数据到Elasticsearch',
        title4: '用于拼接站点页面资源的完整路径',
        async: '同步',
        asyncing: '正在同步中...',
        asyncComplete: '同步完成',
        columnsTemplature: '系统运输方式-ERP温度区分',
        columnsTransport: '系统运输公司-ERP运输公司',
        columnsUrl: '系统内置URL',
        transport: '运输方式',
        transportId: '运输方式id',
        temId: 'ERP温度区分id',
        transportCp: '运输公司',
        transportCpId: '运输公司id',
        erpTransportId: 'ERP运输公司id',
        type: '类型',
        rule1: '请输入站点域名',
        rule2: '请输入站点域名前缀',
        rule3: '请输入图片域名',
        saveSuccess: '保存成功',
        syncError: '同步失败',
        sync60Erp: "同步得意先60天卖上传票",
        appUpgrade: {
          android: 'Android',
          ios: 'IOS',
          forceUpdate: '强制更新',
          versionNumber: '版本号',
          updateContent: '更新内容',
          yes: '是',
          no: '否',
          close: '关闭',
          open: '开启',
          chinese: '中文',
          japanese: '日文',
          traditional: '繁体',
          hideCodeTitle: '隐藏App社会化登录的版本号',
          force: '强制更新',
          noforce: '推荐更新',
          upgradeType: '更新类型'
        }
      },
      picWatermark: {
        previewPic: '预览图（实际尺寸1200*1200）：',
        noTransparent: '1(不透明)',
        fontType1: '普通',
        fontType2: '斜体',
        fontType3: '加粗',
        fontList1: '方正兰亭黑简体',
        positionList1: '中间',
        positionList2: '左上',
        positionList3: '左中',
        positionList4: '左下',
        positionList5: '中上',
        positionList6: '中下',
        positionList7: '右上',
        positionList8: '右中',
        positionList9: '右下',
        error1: '图片类型必须是png格式',
        error2: '图片太大',
        watermarkSwitch: '商品图片添加水印开关',
        watermarkType: '水印类型',
        pic: '图片',
        text: '文字',
        watermarkImg: '水印图片',
        suggestion: '建议上传的水印图片尺寸与商品图片一致，只支持上传PNG图片，上传图片大小不能超过5MB',
        position: '位置',
        offset: '偏移量（像素）',
        content: '水印文字内容',
        placeholder: '请输入',
        font: '字体',
        fontSize: '字体大小（像素）',
        fontType: '字体样式',
        color: '字体颜色',
        offsetW: '横向偏移量（像素）',
        offsetH: '纵向偏移量（像素）',
        transparency: '透明度',
        rotate: '旋转角度（-360-360）',
        rule: '请输入水印文字内容'
      }
    },
    JP: {
      "basicSettings.basicSetting": "基本設定",
      "basicSettings.shopName": "店舗名",
      "basicSettings.pleaseinputShopName": "店舗名を入力してください",
      "basicSettings.operateType": "運営方式",
      "basicSettings.operateTypezero": "複数の発送チャネル、複数の配達方法",
      "basicSettings.operateTypeOne": "複数の発送チャネル、単一の配達方法",
      "basicSettings.operateTypeTwo": "単一の発送チャネル、複数の配達方法",
      "basicSettings.operateTypeThree": "単一の発送チャネル、単一の配達方法",
      "basicSettings.currencySymbol": "通貨記号",
      "basicSettings.currencySymbolPrompt": "左侧显示",
      "basicSettings.currencyUnit": "货币单位",
      "basicSettings.currencyUnitPrompt": "右侧显示",
      "basicSettings.payment": "支払方法",
      "basicSettings.warmPrompt": "ヒント",
      "basicSettings.warmPromptContent": "拖动的修改将直接影响客户下单时支付方式的展示顺序",
      "basicSettings.paymentTimeout": "支付超时时间",
      "basicSettings.chargesSetting": "手续费设置",
      "basicSettings.Watermark": '商品画像の透かし',
      "basicSettings.makeCollectionsBankInformation": "收款银行信息",
      "basicSettings.partnerCode": "商户编号",
      "basicSettings.credentialCode": "开发校验码",
      "basicSettings.shopKey": "商户私钥",
      "basicSettings.zfbKey": "支付宝公钥",
      "basicSettings.secret": "秘钥",
      "basicSettings.minute": "分钟",
      "basicSettings.hour": "小时",
      "basicSettings.day": "天",
      "basicSettings.whethertoAllowBlacklistUse": "是否允许黑名单客户使用",
      "basicSettings.enterPleaseName": "请输入名称",
      "basicSettings.enterPleaseNameMakeCollectionsBankInformation": "请输入收款银行信息",
      "basicSettings.enterPleaseClientKey": "请输入client_key",
      "basicSettings.enterPleaseServerKey": "请输入server_key",
      "basicSettings.enterPleasePartnerCode": "请输入商户编号",
      "basicSettings.enterPleaseSecret": "请输入秘钥",
      "basicSettings.enterPleaseCredentialCode": "请输入开发校验码",
      "basicSettings.enterPleaseAppid": "请输入app_id",
      "basicSettings.enterPleaseShopKey": "请输入商户私钥",
      "basicSettings.enterPleasezfbKey": "请输入支付宝公钥",
      "basicSettings.enterPleasePayPayKey": "请输入key",
      "basicSettings.enterPleasePaymentTimeout": "请输入支付超时时间",
      "basicSettings.tipsForUploadingPicture": "解像度が{size}の画像をアップロードすることをお勧めします。アップロードする画像のサイズは{uploadLimit}MBを超えてはいけません",
      "basicSettings.rewardSetting": "积分设置",
      "basicSettings.rewardGiftRatio": "积分赠送比例(%)",
      "basicSettings.rewardGiftRatioErr": "请输入积分赠送比例",
      "basicSettings.oneRewardConversion": "1积分兑换",
      "basicSettings.oneRewardConversionErr": "请输入一积分兑换金额",
      "basicSettings.evaluatePointRate": "评价积分赠送比例(%)",
      "basicSettings.productMoney": "商品金额范围(含税)",
      "basicSettings.PresentedPointNumber": "赠送积分数量",
      "basicSettings.evaluatePresentIntegralList": "评价赠送积分规则列表",
      "basicSettings.rewardValidity": "积分有效期",
      "basicSettings.rewardValidityUnit0": "天",
      "basicSettings.rewardValidityUnit1": "月",
      "basicSettings.rewardValidityUnit2": "年",
      "basicSettings.rewardValidityErr": "请设置积分有效期",
      "basicSettings.transportCompany": "運送会社",
      "basicSettings.showName": "表示名",
      "basicSettings.parameterConfiguration": "パラメータ設定",
      "basicSettings.newtransportCompany": "新しい運送会社を作成",
      "basicSettings.edittransportCompany": "運送会社を編集",
      "basicSettings.MetaTitle": "Metaタイトル",
      "basicSettings.enterPleaseMetaTitle": "Metaタイトルを入力してください",
      "basicSettings.MetaLabelDescription": "Metaタグの説明",
      "basicSettings.MetaLabelkeyword": "Metaタグのキーワード",
      "basicSettings.other": "その他",
      "basicSettings.productInventoryThreshold": "商品库存阈值",
      "basicSettings.productInventoryThresholdPrompt": "库存低于设定阈值后，管理后台提醒管理员",
      "basicSettings.lowstockLimit": "库存紧张阈值",
      "basicSettings.lowstockLimitPrompt": "库存低于设定阈值后，将在购物页面提示“库存紧张”（包括商品详情页、购物车等）",
      "basicSettings.arrivalNoticeThreshold": "到货通知阈值",
      "basicSettings.arrivalNoticeThresholdPrompt": "库存达到该值，自动发送到货通知",
      "basicSettings.maxLoginNum": "最大ログイン試行回数",
      "basicSettings.maxLoginNumPrompt": "最大試行回数に達し、アカウントは1時間ロックされます",
      "basicSettings.scopeOfDelivery": "发货范围",
      "basicSettings.clientLanguageDisplay": "クライアントの言語表示",
      "basicSettings.shopDefaultLanguage": "既定のストア言語",
      "basicSettings.SameBundleDelivery": "同捆发货",
      "basicSettings.productComment": "商品评论",
      "basicSettings.showProductComment": "显示商品评论",
      "basicSettings.newCommentEmailAlert": "新评论邮件提醒",
      "basicSettings.stepFreight": "阶梯运费",
      "basicSettings.BaiduTranslateappid": "百度翻訳のappid",
      "basicSettings.BaiduTranslateappscript": "百度翻訳のappscript",
      "basicSettings.open": "オン",
      "basicSettings.close": "オフ",
      "basicSettings.piece": "件",
      "basicSettings.arrivalTimeReminder": "到着時間のリマインダーテキスト",
      "basicSettings.leaveWordReminder": "メッセージのリマインダーテキスト",
      "basicSettings.phoneSmsLimit": "1日に1つの電話/顧客あたりのSMS認証コード送信上数限",
      "basicSettings.phoneSmsLimitPrompt": "上限を超えると、その日はその電話/顧客にSMS認証コードは送信されません",
      "basicSettings.ipSmsLimit": "1日に1つのIPあたりのSMS認証コード送信数上限",
      "basicSettings.ipSmsLimitPrompt": "上限を超えると、その日は該当IPの電話番号にSMS認証コードは送信されません",
      "basicSettings.remindSmsLimit": "1日のSMS認証コード送信総量の閾値",
      "basicSettings.remindSmsLimitPrompt": "閾値を超えると、SMSは引き続き送信されますが、送信後には管理者のメールアドレスに超過通知が送信されます",
      "basicSettings.emailSetting": "メール設定",
      "basicSettings.SMTPHost": "SMTPホスト",
      "basicSettings.enterPleaseSMTPHost": "SMTPホストを入力してください",
      "basicSettings.SMTPAccount": "SMTPアカウント",
      "basicSettings.enterPleaseSMTPAccount": "SMTPアカウントを入力してください",
      "basicSettings.SMTPPassword": "SMTPパスワード",
      "basicSettings.enterPleaseSMTPPassword": "SMTPパスワードを入力してください",
      "basicSettings.SMTPPort": "SMTPポート",
      "basicSettings.enterPleaseSMTPPort": "SMTPポートを入力してください",
      "basicSettings.SMTPTimeout": "SMTPタイムアウト（分）",
      "basicSettings.enterPleaseSMTPTimeout": "SMTPタイムアウト（分）を入力してください",
      "basicSettings.administratorEmail": "管理者のメールアドレス",
      "basicSettings.administratorEmailPrompt": "システム異常通知（コンマで区切る）",
      "basicSettings.earlyWarning": "システム警告メールのスイッチ",
      "basicSettings.agreementSetting": "規約設定",
      "basicSettings.registerProtocol": "利用規約",
      "basicSettings.shoppingTerms": "利用規約",
      "basicSettings.returnAndExchangeAgreement": "返品交換ポリシー",
      "basicSettings.privacyPolicy": "個人情報保護方針",
      "basicSettings.pagesetting": 'ページ設定',
      "basicSettings.customerService": "カスタマーサービスに連絡",
      "basicSettings.type": "タイプ",
      "basicSettings.title": "タイトル",
      "basicSettings.description": "説明",
      "basicSettings.link": "リンク",
      "basicSettings.phone": "電話",
      "basicSettings.WeChat": "WeChat",
      "basicSettings.icon": "アイコン",
      "basicSettings.qc-play": "WeChat公式アカウント名",
      "basicSettings.socialLogin": "SNSアカウントログイン設定",
      "basicSettings.orderamountShowdays": "クライアントの注文金額表示日数",
      "basicSettings.emailNotifySetting": "メール通知設定",
      "basicSettings.emailNotifySetting.title": "メール署名",
      "basicSettings.emailNotifySetting.tooltip": "通知メールの署名です",
      'Enable': '有効',
      'disabled': '無効',
      'EnableMessage': '有効にしますか？',
      'disabledMessage': '停止しますか？',
      'yes': 'はい',
      'no': 'いいえ',
      'chinese': '简体中文',
      'chinese2': '繁体中文',
      'jp': '日文',
      'preView': 'プレビュー',
      'emailNumber': '番号',
      'emailNotify': '通知シーン',
      'emailState': '状態',
      'emailAction': '操作',
      'switchSuccess': '点击确定',
      'switchError': 'キャンセルをクリック',
      'more': 'もっと',
      formModel: {
        title: '-パラメータ編集'
      },
      notifySetting: {
        title: '-通知設定',
        title2: '通知設定'
      },
      socialLogin: {
        columns: {
          thirdPlatforms: 'サードパーティープラットフォーム',
          messageNotify: 'メッセージ通知'
        },
        'wxParams1': 'クロスプラットフォームで統一されたアカウントに使用され、PC端末でWeChatスキャンログインに使用',
        'wxParams2': 'メッセージ通知に使用され、WeChatクライアント内でのログインに使用',
        notify: '通知',
        edit: '編集',
        decp: 'ドラッグ操作により並び順と番号を変更でき、表示順序に影響します。',
        wx: 'WeChat',
        qq: 'QQ',
        wb: '新浪微博',
        fb: 'FaceBook',
        line: 'Line',
        wxName1: '微信开放平台',
        wxName2: '海外版WeChat公式アカウント',
        wxName3: '国内版WeChat公式アカウント',
        lineRule1: '入力してくださいChannel ID',
        lineRule2: '入力してくださいChannel Secret',
        lineMessage: 'Lineメッセージ通知を利用する場合は、Channel access tokenを入力してください',
        wxRule1: '入力してくださいApp ID',
        wxRule2: '入力してくださいSecret',
        wbRule1: '入力してくださいApp Key',
        wbRule2: '入力してくださいApp Serect',
        copy: 'コピー',
        open: 'オン',
        socialLogin: '社会化登录',
        look: 'チェック',
        nftoken: '请先编辑配置Channel access token'
      },
      transPort: {
        url: '公式ウェブサイトの検索URL',
        name: '表示名',
        rule1: '運送会社を選択してください',
        rule2: '表示名を入力してください'
      },
      account: {
        emailAccount: 'アカウント',
        name: '名前',
        state: '状態',
        updateTime: '更新時間',
        accountName: 'アカウント',
        EnableMessage: '削除してもよろしいですか？',
        modifyPwd: 'パスワード変更',
        delete: '削除',
        edit: '編集',
        admin: '管理者',
        pwdRule1: 'パスワード（確認用）を入力してください',
        pwdRule2: '新しいパスワードが一致しません',
        pwdRule3: 'パスワードを入力してください',
        pwdRule4: 'パスワードを入力してください',
        nameRule: '名前を入力してください',
        changePwd: 'パスワード変更',
        emailRule: '请输入合法的邮箱',
        emailRule2: '入力してください',
        pwd: 'パスワード',
        newPwd: '新しいパスワード',
        confirmPwd: '新しいパスワード（確認用）',
        confirmPwdPlace: 'パスワード（確認用）を入力してください',
        setAdmin: '管理者に設定',
        yes: 'はい',
        no: 'いいえ',
        pwdLength: 'パスワードを4桁以上に設定してください',
        userLength: '2桁以上の長さのアカウントを入力してください',
        nameLength: '2桁以上の長さの名前を入力してください'
      },
      deploy: {
        siteDomainName: 'サイトのドメイン名',
        title1: 'サイトのページリソースを結合するためのフルーパス',
        title2: '用于拼接站点接口资源的完整路径',
        title3: '画像リソースを結合するためのフルーパス',
        siteInterfacePrefix: '站点接口前缀',
        pictureDomainName: '画像のドメイン名',
        ysDataSync: 'ERPデータと同期する',
        open: 'オン',
        close: 'オフ',
        googleStatus: 'Google Analytics',
        fbStatus: 'Facebook Analytics',
        aliInvalidMailSync: '無効メール同期',
        tbjs: 'Elasticsearchへのデータ同期検索',
        title4: 'サイトのページリソースを結合するためのフルーパス',
        async: '同期',
        asyncing: '同期中...',
        asyncComplete: '同期完了',
        columnsTemplature: '温度区分（ERP）',
        columnsTransport: '運送会社（ERP）',
        columnsUrl: 'システム内蔵URL',
        transport: '配達方法',
        transportId: '配達方法id',
        temId: '温度区分id（ERP）',
        transportCp: '運送会社',
        transportCpId: '運送会社id',
        erpTransportId: '運送会社id（ERP）',
        type: 'タイプ',
        rule1: 'サイトのドメイン名を入力してください',
        rule2: '请输入站点域名前缀',
        rule3: '画像のドメイン名を入力してください',
        saveSuccess: '保存成功',
        syncError: '同期失敗',
        sync60Erp: "伝票を同期する（60日）",
        apiPath: '接口地址',
        errorCount: '报错次数',
        resolved: '标记已解决',
        apiErrorList: '接口报错列表',
        OK: "标记完成",
        deploySetting: '環境設定',
        appUpgrade: {
          android: 'Android',
          ios: 'IOS',
          forceUpdate: '强制更新',
          versionNumber: '版本号',
          updateContent: '更新内容',
          yes: '是',
          no: '否',
          close: '关闭',
          open: '开启',
          chinese: '中文',
          japanese: '日文',
          traditional: '繁体',
          hideCodeTitle: '隐藏App社会化登录的版本号',
          force: '强制更新',
          noforce: '推荐更新',
          upgradeType: '更新类型'
        }
      },
      picWatermark: {
        previewPic: 'プレビュー画像（実際のサイズは1200*1200）：',
        noTransparent: '1(不透明)',
        fontType1: '普通',
        fontType2: '斜体',
        fontType3: '加粗',
        fontList1: '方正兰亭黑简体',
        positionList1: '中央',
        positionList2: '左上',
        positionList3: '左中',
        positionList4: '左下',
        positionList5: '中上',
        positionList6: '中下',
        positionList7: '右上',
        positionList8: '右中',
        positionList9: '右下',
        error1: '画像タイプはPNG形式でなければなりません',
        error2: '画像が大きすぎます',
        watermarkSwitch: '商品画像にウォーターマークを追加するスイッチ',
        watermarkType: '水印类型',
        pic: '图片',
        text: '文字',
        watermarkImg: 'ウォーターマーク画像',
        suggestion: '提案されたウォーターマーク画像のサイズは商品画像と一致し、PNG画像のみをアップロードでき、アップロードする画像のサイズは5MBを超えることはできません',
        position: '位置',
        offset: 'オフセット（ピクセル）',
        content: '水印文字内容',
        placeholder: '入力してください',
        font: '字体',
        fontSize: '字体大小（像素）',
        fontType: '字体样式',
        color: '字体颜色',
        offsetW: '横向偏移量（像素）',
        offsetH: '纵向偏移量（像素）',
        transparency: '透明度',
        rotate: '旋转角度（-360-360）',
        rule: '请输入水印文字内容'
      }
    }
  }
};